import React, {
  createContext,
  useContext,
} from 'react';
import PropTypes from 'prop-types';
import {FormikProvider, FieldArray} from 'formik';
import {useTaskAndNotesGridContext} from '../../_common/contexts/TaskAndNotesGridContext';

const OrderDetailsTaskContext = createContext('');

export function useOrderDetailsTaskContext() {
  return useContext(OrderDetailsTaskContext);
}

export function OrderDetailsTaskProvider({children}) {
  const {formik} = useTaskAndNotesGridContext();

  return (
    <FormikProvider value={formik}>
      <FieldArray name={'tasks'}>
        {(arrayHelpers) => (
          <OrderDetailsTaskContext.Provider value={{arrayHelpers}}>
            {children}
          </OrderDetailsTaskContext.Provider>
        )}
      </FieldArray>
    </FormikProvider>
  );
}

OrderDetailsTaskProvider.propTypes = {
  children: PropTypes.node,
};
